export type UserType = 'student' | 'teacher' | 'schooladmin';

export function isUserType(userType: string): userType is UserType {
  return ['student', 'teacher', 'schooladmin'].includes(userType);
}
